<template>
  <div class="card mb-4 shadow-sm border-radius-xl">
    <div class="card-header pb-0 bg-transparent border-bottom-0">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="font-weight-bolder mb-0 text-uppercase">
            <font-awesome-icon icon="rocket" class="text-primary me-2" />
            Configuración de Mensajes App 3P
          </h6>
          <p class="text-sm mb-0">Personalizá los mensajes automáticos para la aplicación de terceros</p>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="row">
        <div class="col-lg-5 col-md-12">
          <div class="card bg-gray-100 border-radius-lg p-3 mb-4">
            <div class="form-group mb-3">
              <label class="form-control-label text-uppercase text-xs">Inicio de Sesión</label>
              <input class="form-control bg-white" placeholder="Ej: Tu código de acceso es: ${code}" v-model="login_message">
            </div>
            <div class="form-group mb-3">
              <label class="form-control-label text-uppercase text-xs">Retiros</label>
              <input class="form-control bg-white" placeholder="Ej: Se ha solicitado un retiro de: ${amount}" v-model="withdraw_message">
            </div>
            <div class="form-group mb-3">
              <label class="form-control-label text-uppercase text-xs">Nueva Cuenta</label>
              <input class="form-control bg-white" placeholder="Ej: ¡Bienvenido! Tu cuenta ha sido creada." v-model="new_account_message">
            </div>
            <button class="btn bg-gradient-success w-100 mb-0" @click="saveMessages">
              <font-awesome-icon icon="save" class="me-1" />
              Guardar Mensajes
            </button>
          </div>
        </div>
        <div class="col-lg-7 col-md-12">
          <div class="table-responsive">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Login</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Retiros</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nueva Cuenta</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in arrayMessages" :key="key">
                  <td class="align-middle px-3">
                    <p class="text-xs font-weight-bold mb-0">{{item.login_message}}</p>
                  </td>
                  <td class="align-middle px-3">
                    <p class="text-xs font-weight-bold mb-0">{{item.withdraw_message}}</p>
                  </td>
                  <td class="align-middle px-3">
                    <p class="text-xs font-weight-bold mb-0">{{item.new_account_message}}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {get, post} from "@/utils/httpRequest";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRocket, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faRocket, faSave);

export default {
  name: "SMSMessages3P",
  components: {
    FontAwesomeIcon
  },
  data: () => ({
    login_message: "",
    withdraw_message: "",
    new_account_message: "",
    arrayMessages: [],
  }),
  mounted() {
      this.getMessages()
  },
  methods: {
    async getMessages(){
      const {data} = await get("sms-third-party-app")
      this.arrayMessages = data
      if(data.length){
        this.login_message = data[0].login_message
        this.withdraw_message = data[0].withdraw_message
        this.new_account_message = data[0].new_account_message
      }
    },
    async saveMessages(){
      if(this.login_message !== '' || this.withdraw_message !== ''  || this.new_account_message !== '')
        await post("sms-third-party-app/create", {
          login_message: this.login_message,
          withdraw_message: this.withdraw_message,
          new_account_message: this.new_account_message
        })
      this.login_message = ''
      this.withdraw_message = ''
      this.new_account_message = ''
      await this.getMessages()
    }
  }

}

</script>


<style scoped>

</style>
